import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyPriceLabelApiService } from './company-price-label-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyPriceLabelApiService extends GeneratedCompanyPriceLabelApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
